/**
 * @module routes
 * @description Barrel export for application routes
 */

export { default as route } from './routes';
export { default } from './routes';
